function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "value",
  transform: "translate(-70 -24.989)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_116",
  "data-name": "Path 116",
  d: "M213.643,27.218v-.675a1.554,1.554,0,1,0-3.108,0v.675a1.554,1.554,0,1,0,3.108,0Zm-2.7,0v-.675a1.145,1.145,0,1,1,2.289,0v.675a1.145,1.145,0,1,1-2.289,0Z",
  transform: "translate(-135.739)",
  fill: "#333"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_117",
  "data-name": "Path 117",
  d: "M73.845,142.8h5.01a.2.2,0,0,0,.2-.2v-.47h3.43a.2.2,0,0,0,.2-.2V140.59a1.535,1.535,0,0,0-1.437-1.531.239.239,0,0,0-.211.117.94.94,0,0,1-1.482-.036.2.2,0,0,0-.17-.083,1.518,1.518,0,0,0-.753.22,1.721,1.721,0,0,0-1.2-.6.249.249,0,0,0-.211.123,1.1,1.1,0,0,1-1.74-.042.2.2,0,0,0-.17-.083,1.714,1.714,0,0,0-1.189.519c-.026.026-.05.054-.074.082a1.522,1.522,0,0,0-.7-.219.239.239,0,0,0-.211.117.94.94,0,0,1-1.482-.036.205.205,0,0,0-.17-.083A1.534,1.534,0,0,0,70,140.59v1.329a.2.2,0,0,0,.2.2H73.64v.47A.2.2,0,0,0,73.845,142.8Zm5.462-3.326a1.349,1.349,0,0,0,2.02.005,1.126,1.126,0,0,1,.958,1.112v1.124H79.06V140.4a1.713,1.713,0,0,0-.189-.784A1.107,1.107,0,0,1,79.307,139.473Zm-4.076-.379a1.512,1.512,0,0,0,2.284.005,1.315,1.315,0,0,1,1.135,1.3v1.988h-4.6V140.4A1.323,1.323,0,0,1,75.231,139.094Zm-4.822,2.62V140.59a1.132,1.132,0,0,1,1-1.117,1.349,1.349,0,0,0,2.02.005,1.117,1.117,0,0,1,.4.141,1.715,1.715,0,0,0-.187.782v1.313Z",
  transform: "translate(0 -109.809)",
  fill: "#333"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_118",
  "data-name": "Path 118",
  d: "M333.9,52.236v-.591a1.386,1.386,0,0,0-2.772,0v.591a1.386,1.386,0,0,0,2.772,0Zm-2.362,0v-.591a.976.976,0,1,1,1.953,0v.591a.976.976,0,1,1-1.953,0Z",
  transform: "translate(-252.219 -24.409)",
  fill: "#333"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_119",
  "data-name": "Path 119",
  d: "M102.418,52.236v-.591a1.386,1.386,0,0,0-2.772,0v.591a1.386,1.386,0,0,0,2.772,0Zm-2.362,0v-.591a.976.976,0,1,1,1.953,0v.591a.976.976,0,1,1-1.953,0Z",
  transform: "translate(-28.634 -24.409)",
  fill: "#333"
}));

var SvgValue = function SvgValue(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12.694,
    height: 8,
    viewBox: "0 0 12.694 8",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgValue, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/value.22ea6aa2.svg";
export { ForwardRef as ReactComponent };